<style>
    .spec-options .spec-select {
        overflow-y: scroll;
    }
</style>
<template>
    <transition name="ncbottom">
        <div class="nctouch-bottom-mask mask-show" v-if="show">
            <div class="nctouch-bottom-mask-bg" @click="bindHide()" @touchmove="excludeTouch"></div>
            <div class="nctouch-bottom-mask-block">
                <div class="spec-options">

                    <div class="spec-img" @touchmove="excludeTouch">
                        <img :src="currentGoodsInfo.imageSrc">
                    </div>
                    <div class="spec-close" @click="bindHide()"></div>
                    <div class="spec-menu-top" @touchmove="excludeTouch">

                        <slot name="pricePanel"></slot>
                        <div class="top-price" v-if="showDefaultPricePanel">
                            Ks <em>{{currentGoodsPrice | $convertPrice}}</em></div>
                        <div class="top-number">ပစၥၫ္းနံပါတ္:{{currentGoodsInfo.goodsId}}</div>
                    </div>
                    <div class="spec-select" ref="scroll">
                        <div class="prod-spec">

                            <dl class="spec" v-for="(specItem,specIndex) in specJson">
                                <dt>{{specItem.specName}}</dt>
                                <dd>
                                    <a href="javascript:;"
                                       :class="{'current':inSpecValueQueue(specIndex,specValueItem.specValueId)}"
                                       @click="bindSelectSpec(specIndex ,specValueItem.specValueId)"
                                       v-for="specValueItem in specItem.specValueList">
                                        {{specValueItem.specValueName}}
                                    </a>
                                </dd>
                            </dl>

                            <dl class="spec">
                                <dt v-if="canBuyForSku">အေရအတြက္
                                <div class="spec-count">
                                    <a class="minus" href="javascript:;" @click="bindMinusNum()"><em
                                            :class="{'no-change' : mNoChange}"></em></a>
                                    <input class="quantity" v-model.trim.number="buyNum" type="number">
                                    <a class="add" href="javascript:;" @click="bindAddNum()"><em
                                            :class="{'no-change' : aNoChange}"></em></a>
                                </div>
                                </dt>
                                <dt v-else data-name="无库存">
                                  ကုန္ပစၥည္းမရွိ
                                </dt>
                            </dl>
                        </div>
                    </div>
                    <div class="layout" v-show="!shopingListIsEmpty()">
                        <div class="shopping-summary">
                            <a href="javascript:;">共{{currentShopingInfo.sum}}，<em>Ks{{currentShopingInfo.amount | $convertPrice}}</em></a>
                        </div>
                    </div>
                    <div class="goods-shopping-list" v-show="showShopingList " ref="showShopingLayer">
                        <ul>
                            <li v-for="(itemS , indexS) in shopingList">
                                <span class="selected-checkbox">
                                    <input type="checkbox" class="checkbox" :value="itemS.goodsId"
                                           @click="bindAddDelArray(itemS.goodsId)">
                                </span>
                                <span class="selected-sku"> {{itemS.goodsSpecString}}</span>
                                <span class="selected-num">{{itemS.buyNum}}{{itemS.unitName}}</span>
                            </li>
                        </ul>
                    </div>
                    <slot name="btnPanel"></slot>
                    <div class="nc-reselect-foot" v-if="showDefaultBtnPanel">

                        <div class="concern-cart" v-show="showShopingList">
                            <a href="javascript:;" @click="bindShoppingListDelete()" @touchmove.stop="excludeTouch"
                               class="handle w50">
                              <!--<em class="cart"></em>-->
                              <span>Delete</span></a>
                            <a href="javascript:;" @click="showShopingList = false " @touchmove.stop="excludeTouch"
                               class="handle w50">
                              <!--<em class="cart"></em>-->
                              <span>Close</span></a>
                        </div>
                        <div class="concern-cart" v-show="!showShopingList && specJson.length">
                            <a href="javascript:;" @click="bindShowShopingPanel()" @touchmove.stop="excludeTouch"

                               class="handle w100">
                              <!--<em class="cart"></em>-->
                                <span data-name="已选清单">ေ႐ြးထားေသာစာရင္း</span></a>
                        </div>

                        <div class="action-list">
                            <a class="green-btn" @click="bindAddCart()" @touchmove.stop="excludeTouch"
                               href="javascript:;">
                                <p>{{buttonText}}</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    /**
     * 一个简单的商品sku重新选择
     */
//    import BScroll from 'better-scroll'
    export default {
        name: "nc-goods-reselect-wholesale",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            buttonText: {
                type: String,
                default: "တြန္းလွည္းထဲထည့္ရန္"
            },
            goodsId: {
                type: Number,
                required: false
            },
            goodsCommon: {
                type: Object
            }
        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {
                //specValue 队列
                selectSpecValueQueue: [],
                // 当前的goodsId
                currentGoodsId: 0,
                oldBuyNum: 0,
                //减号不能点标识
                mNoChange: true,
                //加好不能点标识
                aNoChange: false,
//                scrollInstance: null,
                //已选清单显示标识
                showShopingList: false,
                //已选清单
                shopingList: {},
                //购物清单删除列表
                delArray: [],
            }
        },
        /**
         * 计算属性
         */
        computed: {
            defaultGoodsId: function () {
                var _specJson = this.goodsCommon.specJson,
                    _goodsSpecValueJson = this.goodsCommon.goodsSpecValueJson,
                    _defaultArray = [];
                //如果没有规格就goodlist 的头一个
                if (!_specJson.length) {
                    return this.goodsCommon.goodsList[0].goodsId
                }
                _defaultArray = _specJson.map(function (value) {
                    return value.specValueList[0].specValueId
                })
                var _currentSpecJson = _goodsSpecValueJson.filter(function (value) {
                    var a = _defaultArray.slice(0),
                        b = value.specValueIds;
                    return a.sort().toString() == b.sort().toString()
                })[0];
                return _currentSpecJson.goodsId
            },
            //根据客户端不同，返回不同促销进行状态
            isUsable: function () {
                return getUsable(this.currentGoodsInfo)
            },
            // 起批量样式
            tClassObject: function () {
                var _tClassString = '', result = {
                    'clearfix': true
                };
                if (this.goodsCommon.batchNum2 > 0) {
                    _tClassString = 't3'
                } else if (this.goodsCommon.batchNum1 > 0) {
                    _tClassString = 't2'
                } else {
                    _tClassString = 't1'
                }
                result[_tClassString] = true
                return result
            },
            specJson: function () {
                return this.goodsCommon.specJson;
            },
            goodsSpecValueJson: function () {
                return this.goodsCommon.goodsSpecValueJson
            },
            goodsList: function () {
                return this.goodsCommon.goodsList
            },
            /**
             * 已选清单信息
             */
            currentShopingInfo: function () {
                var _amount = 0,
                    _sum = 0,
                    _unit = this.goodsCommon.unitName,
                    _shopList = this.shopingList,
                    _currentGoodsPrice = this.currentGoodsPrice,
                    _buyNum = this._getBuyNumAll(),
                    _buyNumTemp = this.buyNum
                ;
                return {
                    amount: Nc.number.multi(_buyNum, _currentGoodsPrice),
                    sum: _buyNum + _unit
                }
            },
            /**
             * 当前商品价格
             */
            currentGoodsPrice: function () {
                var _price = 0,
                    _currentGoodsInfo = this.goodsCommon,
                    _buyNum = this._getBuyNumAll(),
                    _buyNumTemp = this.buyNum
                ;
                if (_buyNum >= _currentGoodsInfo.batchNum2 && _currentGoodsInfo.batchNum2 != 0) {
                    _price = getPrice2(_currentGoodsInfo);
                } else if (_buyNum >= _currentGoodsInfo.batchNum1 && _currentGoodsInfo.batchNum1 != 0) {
                    _price = getPrice1(_currentGoodsInfo);
                } else {
                    _price = getPrice0(_currentGoodsInfo);
                }

                return parseFloat(_price);
            },


            /**
             * 当前商品信息
             */
            currentGoodsInfo: function () {
                var _goodsId = this.currentGoodsId || this.goodsId;
                return this.goodsList.filter(function (item) {
                        return item.goodsId == _goodsId
                    }
                )[0]
            },
            /**
             * 购买数量 取值于赋值
             */
            buyNum: {
                get() {
                    return this.oldBuyNum;
                },
                set(newValue, oldValue) {
                    let _num = parseInt(newValue),
                        //库存
                        _goodsStorage = this.currentGoodsInfo.goodsStorage,
                        _goodsId = this.currentGoodsInfo.goodsId,
                        _shopingList = this.shopingList
                    ;
                    //如果小于1 就直接是1
                    if (_num < 0) {
                        this.oldBuyNum = 0
                        return
                    }
                    //为最终的显示数量赋值
                    this.oldBuyNum = _num > _goodsStorage ? _goodsStorage : _num;

                    //改变加减号是否能点
                    this.mNoChange = this.oldBuyNum <= 0 ? true : false;
                    this.aNoChange = this.oldBuyNum == _goodsStorage ? true : false

                    //如果数量减少成0 ，就删除
                    if (this.oldBuyNum <= 0) {
                        _shopingList [_goodsId] && ( delete _shopingList[_goodsId] )
                    } else {
                        //添加到已选列表
                        this.addCurrentGoodsToShopingList();
                    }
                    this.$forceUpdate();
                }
            },
            /**
             * 当前sku是否能够购买
             */
            canBuyForSku: function () {
                var _currentGoodsInfo = this.currentGoodsInfo,
                    _currentStorge = _currentGoodsInfo.goodsStorage
                ;
                return _currentStorge > 0
            },
            /**
             * 是否能购买
             */
            canBuy: function () {

                var _amount = 0,
                    _sum = 0,
                    _shopList = this.shopingList,
                    _goodsCommon = this.goodsCommon,
                    //监听购买数量变动
                    _buyNum = this.buyNum
                ;
                for (var goodsItem in _shopList) {
                    _sum = Nc.number.add(_sum, _shopList[goodsItem].buyNum);
                }
                return _sum >= _goodsCommon.batchNum0
            },

            // 是否显示底部按钮
            showDefaultBtnPanel (){
                return this.$slots.btnPanel ? false : true
            },

            // 是否显示价格区域
            showDefaultPricePanel(){
                return this.$slots.pricePanel ? false : true
            },
          print(){
              console.log(789)
          }
        },

        /**
         * 过滤器
         */
        filters: {
            getPrice0: function (value) {
                return getPrice0(value)
            },
            getPrice1: function (value) {
                return getPrice1(value)
            },
            getPrice2: function (value) {
                return getPrice2(value)
            },
            minPrice(value) {
                return getPrice0(value)
            },

            //替换;成,号
            replaceLetter: function (value) {
                return value.replace(/；+/g, ",")
            }
        },
        created(){
          this.print();
        },
        mounted(){

        },
        /**
         * 监听属性变动
         */
        watch: {
            show(newValue, oldValue) {
                this.currentGoodsId = this.goodsId ? this.goodsId : this.defaultGoodsId
                this.addSelectSpecValueQueue(this.currentGoodsId)
                if (newValue) {
//                    this.$nextTick(() => {
//                        if (!this.$refs.scroll) return
//                        if (this.scrollInstance) {
//                            this.scrollInstance.refresh()
//                        } else {
//                            this.scrollInstance = new BScroll(this.$refs.scroll, {
//                                startX: 0,
//                                startY: 0,
//                                scrollX: false,
//                                scrollY: true,
//                                click: true,
//                            });
//                        }
//                    })
                }


            }

        },
        /**
         * 自定义方法
         */
        methods: {   //获取全部商品的购买数量
            _getBuyNumAll: function () {
                var _shopingList = this.shopingList,
                    num = 0;
                if (!Nc.isEmpty(this.shopingList)) {
                    for (var item in _shopingList) {
                        console.log(_shopingList[item])
                        num = Nc.number.add(_shopingList[item].buyNum, num)
                    }
                }
                return num;

            },

            /**
             * 购买的数据
             */
            buyData() {

                var self = this,
                    _sum = 0,
                    _wholesaleArray = [],
                    _shopList = this.shopingList,
                    _currentGoodsId = this.currentGoodsInfo.goodsId
                ;
                for (var goodsItem in _shopList) {
                    var goodsInfo = _shopList[goodsItem];
                    _sum = Nc.number.add(_sum, goodsInfo.buyNum);
                    _wholesaleArray.push({
                        goodsId: goodsInfo.goodsId,
                        buyNum: goodsInfo.buyNum
                    })
                }
                return {
                    buyNum: _sum,
                    goodsId: _currentGoodsId,
                    wholesale: _wholesaleArray
                }
            },

            /**
             * 购买前验证
             * @param cb
             */
            verifyBuy: function (cb) {

                var _buyData = this.buyData(),
                    _goodDetail = this.goodsCommon
                ;
                console.log("goods-wholesale-spec-select.vue->_buyData", _buyData)
                if (_buyData && _buyData.wholesale && _buyData.wholesale.length) {
                    if (this.canBuy) {
                        cb.call(this, _buyData.wholesale)
                    } else {
                      alertWarn('အနည္းဆုံးဝယ္ယူ'+ _goodDetail.batchNum0 + _goodDetail.unitName);//最少采购
                    }
                } else {
                  alertWarn("ကုန္ပစၥည္းအရင္ေ႐ြးပါ");//请先选择商品
                }
            },

            //判断已选列表是否为空
            shopingListIsEmpty: function () {
                return Nc.isEmpty(this.shopingList)
            },
            //去除无关的touch事件
            excludeTouch: function (event) {
                event.preventDefault();
                return false;
            },
            //添加到已选列表
            addCurrentGoodsToShopingList(){

                var _currentGoodsInfo = this.currentGoodsInfo,
                    _currentGoodsId = _currentGoodsInfo.goodsId,
                    _buyNum = this.buyNum;
                if (_buyNum) {
                    this.shopingList [_currentGoodsId] = {
                        goodsId: _currentGoodsId,
                        buyNum: _buyNum,
                        goodsSpecString: _currentGoodsInfo.goodsSpecString,
                        unitName: _currentGoodsInfo.unitName
                    };
                    this.shopingList [_currentGoodsId].price = this.currentGoodsPrice
                } else {
                    delete this.shopingList [_currentGoodsId];
                }


            },

            //判断是否在规格值队列中
            inSpecValueQueue(index, specValue) {
                return this.selectSpecValueQueue[index] == specValue
            },
            //获取goodsId 根绝规格值
            setGoodsIdForSpecJson: function () {
                var self = this
                var _specJson = this.goodsSpecValueJson.filter(function (value) {
                    var a = self.selectSpecValueQueue.slice(0),
                        b = value.specValueIds;
                    return a.sort().toString() == b.sort().toString()
                })[0];
                if (!_specJson) return;
                this.currentGoodsId = _specJson.goodsId
                this.$emit('eventModSkuId', _specJson.goodsId)
            },
            //根绝goodsid 获取规格值数组并加入队列
            addSelectSpecValueQueue(goodsId) {

                var _specValueObj = this.goodsSpecValueJson.filter(function (item) {
                    return item.goodsId == goodsId
                })[0];
                if (_specValueObj) {
                    this.selectSpecValueQueue = _specValueObj.specValueIds.slice(0);

                }

            },
            //点击规格值
            bindSelectSpec(index, specValue) {
                this.selectSpecValueQueue.splice(index, 1, specValue)
                this.setGoodsIdForSpecJson()
                //购买数量修改
                var _currentShoping = this.shopingList[this.currentGoodsId];
                if (_currentShoping) {
                    this.buyNum = _currentShoping.buyNum;
                } else {
                    this.buyNum = 0;
                }
            },
            //隐藏
            bindHide() {
                //向父组建发送消息
                this.$emit('hide', this.buyData())
            },
            //购买数量减少
            bindMinusNum: function () {
                this.buyNum--
            },
            //购买数量增加
            bindAddNum: function () {
                this.buyNum++
            },

            //添加到购物车
            bindAddCart: function () {
                this.verifyBuy(function (buyData) {
                    console.log('添加到购物车')
                    this.$emit('submit', buyData)
                });
            },
           
            //点击 显示已选购物清单
            bindShowShopingPanel: function () {
                var self = this;
                if (this.shopingListIsEmpty()) {
                  alertWarn('ဝယ္ယူေသာအေရတြက္ေ႐ြးပါ');//请选择购买数量
                    return
                }
                this.showShopingList = true;
//                this.$nextTick(function () {

//                    if (shopingIScrollInstance) return;
//                    shopingIScrollInstance = new BScroll(self.$refs.showShopingLayer, {
//                        scrollX: false,
//                        scrollY: true
//                    });
//                })
            },

            //点击添加到删除列表
            bindAddDelArray: function (goodsId) {
                var _delArray = this.delArray,
                    index = _delArray.indexOf(goodsId)
                ;
                if (index < 0) {
                    this.delArray.push(goodsId)
                } else {
                    _delArray.splice(index, 1);
                }
            },
            //删除已选清单
            bindShoppingListDelete(){
                var _delArray = this.delArray,
                    _shopingList = this.shopingList,
                    _currentId = this.currentGoodsInfo.goodsId,
                    self = this
                ;
                _delArray.forEach(function (cValue) {
                    if (_shopingList[cValue]) {
                        delete _shopingList[cValue]
                        if (_currentId == cValue) {
                            self.buyNum = 0
                        }
                    }
                })
                _delArray.splice(0)
            },
            //到货通知
            bindArrivalNotice: function () {
                var _goodsId = this.currentGoodsInfo.goodsId
                this.$emit('arrivalnotice', _goodsId)

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/base-components/goods-reselect-wholesale/goods-reselect-wholesale.vue